import React, { useRef } from 'react';
import { useEvent } from '../../../../../../../../hooks/useEvent';
import { useFilterState } from '../state';
import FilterBtn from '../FilterBtn';
import DspxPopover from '../../../../../../../../components/DspxPopover/DspxPopover';
import Content from './content';
import { getPopupContainer } from '../utils';

const SearchFilter = ({ name, placeholder }) => {
  const inputRef = useRef();

  const {
    value,
    setValue,
    visible,
    onVisibleChange,
    onOk,
    onReset,
    hasFilterValue,
  } = useFilterState(name, {
    visibleChangeCb: (visible) => {
      if (visible) {
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        });
      }
    },
  });

  const handleChange = useEvent((e) => {
    setValue(e.target.value);
  });

  return (
    <DspxPopover
      arrow={false}
      trigger="click"
      visible={visible}
      onVisibleChange={onVisibleChange}
      getPopupContainer={getPopupContainer}
      placement="bottomLeft"
      content={
        <Content
          onChange={handleChange}
          onOk={onOk}
          onReset={onReset}
          placeholder={placeholder}
          inputRef={inputRef}
          value={value}
        />
      }
    >
      <FilterBtn iconType="search" active={hasFilterValue} />
    </DspxPopover>
  );
};

export default SearchFilter;
